import React, {Component} from 'react';
import IFrameContainer from "../../utils/IFrameContainer";
import WindowDimensions from "../../utils/WindowDimensions";

class ServiceContainer extends Component {

    constructor(props) {

        super(props);

    }

    render() {

        const url = 'https://faq.zsk.de/x/A4AZ';    //  https://faq.zsk.de
        const containerHeight = WindowDimensions.getWindowDimensions('contentAreaHeight');

        return (
            <div className="serviceContainer" style={{'height': containerHeight + 'px', position: 'relative'}}>
                <div>
                    <IFrameContainer
                        id="serviceFrame"
                        src={url}
                    />
                </div>
            </div>
        );

    }

}

export default ServiceContainer;
